import { useQuery, UseQueryOptions } from 'react-query';

import { ProjectsQueryApi } from '@lib/api/endpoints';
import { buildEnhancedClientEnvironment } from '@lib/utils/clientEnvironment';

type UseClientEnvironmentOptions = {
  useQueryOptions?: UseQueryOptions<
    EnhancedClientEnvironment,
    unknown,
    EnhancedClientEnvironment,
    string[]
  >;
};

// this can be used without authentication, because its a public endpoint
export const useClientEnvironment = (
  options: UseClientEnvironmentOptions = {}
) => {
  const { useQueryOptions = {} } = options;
  const clientEnvironmentId = Number(
    process.env.NEXT_PUBLIC_CLIENT_ENVIRONMENT_ID
  );
  const isQueryEnabled = Number.isInteger(clientEnvironmentId);
  const result = useQuery({
    queryKey: ['clientEnvironment'],
    queryFn: async (): Promise<EnhancedClientEnvironment> => {
      const environmentFromApi = await ProjectsQueryApi.getClientEnvironment(
        clientEnvironmentId
      );
      return buildEnhancedClientEnvironment(environmentFromApi);
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: isQueryEnabled,
    staleTime: 60 * 60 * 1000, // 1 hour
    ...useQueryOptions,
  });

  return result;
};
